import Vue from 'vue';
import http from './http_services';
import storage from './mod_storage';
import manipulation_helpers from './mod_manipulation_helpers';

const session = {
  expiration_days: 30,
	state: {
    logged_in: false,
    default_userid: 1,
		user: {
      id: 1,
      email: ''
    }
	},

  log_in: function(email_address, email_consent) {
    // FAKE LOGIN FOR TESTING
    let vm = this;

    // IF ALREADY LOGGED IN
    if(vm.check_login_status) {
      // LOG OUT
      vm.log_out();
    }

    // PREP DATA
    let data = {
      email: email_address,
      login_email_opt_in: email_consent,
      requested_action: 'login_user'
    }

    // TRY LOGIN
    return http.make_simple_post(data)
      .then(function(response) {
        // console.log('login response: ', response);
        if(response.data) {
          if(response.data.data) {
            if(response.data.data.user) {
              // UPDATE LOCAL STATE
              Vue.set(vm.state, 'logged_in', true);
              Vue.set(vm.state.user, 'id', response.data.data.user.id);
              Vue.set(vm.state.user, 'email', response.data.data.user.email);
              
              // UPDATE STORAGE
              storage.set_item('user_data', {
                id: vm.state.user.id,
                email: vm.state.user.email
              })
            }
          }
        }
      })
  },

  log_out: function() {
    let vm = this;

    // RESET LOCAL STATE
    Vue.set(vm.state, 'logged_in', false);
    Vue.set(vm.state, 'user', {id: 0, email: ''});

    // RESET STORAGE
    storage.remove_item('user_data');
    storage.remove_item('super_category_list');
  },

  check_login_status: function() {
    if(this.state.logged_in === true) {
      return true;
    }
    else {
      return false;
    }
  },

  check_stored_login: function() {
    let vm = this;

    // CHECK STORAGE FOR LOGGED IN USER
    vm.fetch_stored_login()
      .then(function(vf_response) {
        if(vf_response) {
          // CHECK FOR REQUIRED DATA IN STORAGE
          if(vf_response.email && vf_response.id && vf_response.last_modified) {
            // CHECK IF LOGIN HAS EXPIRED
            let now = new Date();
            let diff = manipulation_helpers.check_timestamp_diff(vf_response.last_modified, now.getTime());
            
            if(diff.days >= vm.expiration_days) {
              // SESSION HAS EXPIRED. FORCE FULL LOGOUT
              vm.log_out();
            }
            else {
              // SESSION IS STILL VALID. LOAD IT.
              Vue.set(vm.state, 'logged_in', true);
              Vue.set(vm.state.user, 'id', vf_response.id);
              Vue.set(vm.state.user, 'email', vf_response.email);
            }
          }
        }
      })
      .catch(function(error) {
        // console.log('error: ', error);
      })
  },

  fetch_stored_login: function() {
    let vm = this;

    // CHECK STORAGE FOR LOGGED IN USER
    return storage.get_item('user_data');
  },

  get_userid: function() {
    let vm = this;

    // CHECK IF USER ID IS DEFAULT
    if(vm.state.user.id == vm.state.default_userid) {
      // FOUND DEFAULT ID, NEED NEW DATA. 
      // TRY TO GET STORED DATA
      vm.fetch_stored_login()
        .then(function(response) {
          // CHECK FOR REQUIRED DATA IN STORAGE
          if(typeof response != 'undefined' && response != 'null' && response != null) {
            if(typeof response.email != 'undefined' 
              && typeof response.id != 'undefined' 
              && typeof response.last_modified != 'undefined') 
            {
              Vue.set(vm.state, 'logged_in', true);
              Vue.set(vm.state.user, 'id', response.id);
              Vue.set(vm.state.user, 'email', response.email);
            }

            return vm.state.user.id;
          }
          else {
            return vm.state.user.id;
          }
          

        })
    }
    else {
      return vm.state.user.id;
    }

    
  },

  get_user_email: function() {
    return vm.state.user.email;
  }
}

export default session


// WEBPACK FOOTER //
// ./src/store/modules/mod_session.js